/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


 document.addEventListener('product:added', function(event) {
  var variant = event.detail.variant; // Get the variant that was added
  var quantity = event.detail.quantity; // Get the quantity that was added
  var item = document.getElementById("nav-item-count");
  var cartQuantity = item.innerHTML; // get the current quantity in cart
  var updatedQuanity = parseInt(cartQuantity) + parseInt(quantity);
  console.log(quantity);
  console.log(cartQuantity);
  console.log(updatedQuanity);

  item.innerHTML = updatedQuanity;
	
 });

function subtractLineItem(e){
  console.log ("hit the button");
  var target = e.target; // Get the element for that button
  var nextSib = target.nextElementSibling.value;
  console.log("Line item quantity: " + parseInt(nextSib-1));

  var item = document.getElementById("nav-item-count");
  var cartQuantity = item.innerHTML; // get the current quantity in cart
  var updatedQuanity = parseInt(cartQuantity) - 1;

  console.log(cartQuantity);
//   console.log(updatedQuanity);

  item.innerHTML = updatedQuanity;
	
}

function addLineItem(e){
  console.log ("hit the button");
  var target = e.target; // Get the element for that button
  console.log (target.previousElementSibling );

  var prevSib = target.previousElementSibling;
  console.log("Line item quantity: " + parseInt(prevSib-1));

  var item = document.getElementById("nav-item-count");
  var cartQuantity = item.innerHTML; // get the current quantity in cart
  var updatedQuanity = parseInt(cartQuantity) + 1;

  console.log(cartQuantity);

  item.innerHTML = updatedQuanity;
}

function removeLineItem(e){
  console.log ("hit the button");
  var target = e.target; // Get the element for that button
  var prevSib = target.previousElementSibling;
  console.log(prevSib);
  var prevChildSib = prevSib.firstElementChild;
  console.log("Regular: " + prevChildSib);
  var quantityValue = prevChildSib.children[1];
  console.log("Quantity: " + quantityValue.value);

  
  var item = document.getElementById("nav-item-count");
  var cartQuantity = item.innerHTML; // get the current quantity in cart
  var updatedQuanity = (parseInt(cartQuantity) - quantityValue.value);

  item.innerHTML = updatedQuanity;
	
}

document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('form.Footer__Newsletter, form.Newsletter').forEach(function(theForm){

        var elHide = function(el){
            el.style.display = 'none';
            return el;
        };

        var elShow = function(el){
            el.style.display = 'block';
            return el;
        };

        theForm.addEventListener('submit', function(e){
            e.preventDefault();
            e.stopImmediatePropagation();

            var urlParams = new URLSearchParams(window.location.search);

            var url = 'https://t1rrtnfujd.execute-api.us-west-2.amazonaws.com/subscribe';

            var elEmail = theForm.querySelector('input[name="contact[email]"]');
            var elSuccess = elHide(theForm.querySelector('.Alert--success'));
            var elError = elHide(theForm.querySelector('.Alert--error'));

            var postData = {
                email: elEmail.value,
                source: theForm.querySelector('input[name="source"]').value,
                utm_campaign: urlParams.get('utm_campaign'),
                utm_medium: urlParams.get('utm_medium'),
                utm_source: urlParams.get('utm_source')
            };

            fetch(url, {
                method: 'post',
                body: JSON.stringify(postData),
                headers: {
                    'content-type': 'application/json'
                }
            }).then((response) => {
                return response.json();
            }).then((res) => {
                if(res.code == 1) {
                    elError.innerHTML = res.message;
                    elShow(elError);
                    elHide(elSuccess);
                    // console.log('error: ' + res.message);
                }
                if(res.code == 0) {
                    elEmail.value = "";
                    elShow(elSuccess);
                    elHide(elError);
                    //console.log('success: ' + res.message);
                    setTimeout(function(){
                        elHide(elSuccess);
                    }, 5000);
                }
            }).catch((exception) => {
                // console.log(exception);
                elError.innerHTML = "Error submitting your request";
                elHide(elSuccess);
                elShow(elError);
            });
        });
    });
});

